import classNames from "classnames";
import React, { useEffect, useRef } from "react";

import { useSelector } from "../../utils/hooks";
import strings from "../../utils/strings";

interface DrawerPropsI {
	children: React.ReactNode;
}

export const Drawer = ({ children }: DrawerPropsI) => {
	const isVisible = useSelector((state) => state.popup.products.isVisible);

	const drawerRef = useRef(null);
	const previouslyFocusedElement = useRef(null);

	useEffect(() => {
		if (isVisible) {
			previouslyFocusedElement.current = document.activeElement;

			setTimeout(() => {
				const focusableElements = drawerRef.current?.querySelectorAll(
					'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
				);

				if (focusableElements && focusableElements.length > 0) {
					focusableElements[0].focus();
				}
			}, 100);

			const handleKeyDown = (e) => {
				if (e.key === "Tab") {
					const focusableElements = drawerRef.current?.querySelectorAll(
						'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
					);

					if (!focusableElements || focusableElements.length === 0) return;

					const firstElement = focusableElements[0];
					const lastElement = focusableElements[focusableElements.length - 1];

					if (e.shiftKey) {
						// Shift + Tab
						if (document.activeElement === firstElement) {
							e.preventDefault();
							lastElement.focus();
						}
					} else {
						// Tab
						if (document.activeElement === lastElement) {
							e.preventDefault();
							firstElement.focus();
						}
					}
				}
			};

			document.addEventListener("keydown", handleKeyDown);

			return () => {
				document.removeEventListener("keydown", handleKeyDown);
			};
		} else {
			// Restore focus to the previously focused element
			if (previouslyFocusedElement.current) {
				previouslyFocusedElement.current.focus();
				previouslyFocusedElement.current = null;
			}
		}
	}, [isVisible]);

	return (
		<div
			ref={drawerRef}
			{...(!isVisible && { inert: false })}
			aria-hidden={`${!isVisible}`}
			aria-label={strings.popupAddToCart}
			className={classNames({
				"addtocart-drawer-container": true,
				caas: true,
				"show-element": isVisible,
			})}
		>
			{children}
		</div>
	);
};
